import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
const DEFAULT_ASSOCIATION_FN = () => true;
function makeDefaultAssociationConfig(associationName) {
  return {
    associationName,
    isEnabled: DEFAULT_ASSOCIATION_FN
  };
}

/**
 * Set up which CRM associations should be used by each object type id.
 */
export function getAssociationConfig(objectTypeId, campaignsAssociationSettings = {}) {
  switch (objectTypeId) {
    default:
      return [];
    case OBJECT_TYPE.BLOG_POST:
      return [makeDefaultAssociationConfig('BLOG_POST_TO_CAMPAIGN')];
    case OBJECT_TYPE.CAMPAIGN:
      {
        const fasPoweredAssociations = Object.keys(campaignsAssociationSettings).map(objectType => {
          const {
            inverseAssociationEnumValue,
            requiredGates,
            requiredPortalScopes
          } = campaignsAssociationSettings[objectType].campaignsAssociations.metadata;
          return {
            associationName: inverseAssociationEnumValue.value,
            isEnabled: ({
              hasScope,
              isUngatedFor
            }) => ((requiredGates === null || requiredGates === void 0 ? void 0 : requiredGates.value) || []).every(isUngatedFor) && ((requiredPortalScopes === null || requiredPortalScopes === void 0 ? void 0 : requiredPortalScopes.value) || []).every(hasScope)
          };
        });
        return [makeDefaultAssociationConfig('CAMPAIGN_TO_AD_CAMPAIGN'), makeDefaultAssociationConfig('CAMPAIGN_TO_AUTOMATION_PLATFORM_FLOW'), makeDefaultAssociationConfig('CAMPAIGN_TO_BLOG_POST'), makeDefaultAssociationConfig('CAMPAIGN_TO_WEB_INTERACTIVE'), makeDefaultAssociationConfig('CAMPAIGN_TO_CTA'), makeDefaultAssociationConfig('CAMPAIGN_TO_FORM'), makeDefaultAssociationConfig('CAMPAIGN_TO_LANDING_PAGE'), makeDefaultAssociationConfig('CAMPAIGN_TO_MARKETING_EMAIL'), makeDefaultAssociationConfig('CAMPAIGN_TO_MARKETING_EVENT'), makeDefaultAssociationConfig('CAMPAIGN_TO_SITE_PAGE'), makeDefaultAssociationConfig('CAMPAIGN_TO_SOCIAL_BROADCAST'), makeDefaultAssociationConfig('CAMPAIGN_TO_MARKETING_SMS'), ...fasPoweredAssociations];
      }
    case OBJECT_TYPE.CONTENT:
      return [makeDefaultAssociationConfig('CONTENT_TO_CAMPAIGN')];
    case OBJECT_TYPE.FORM:
      return [makeDefaultAssociationConfig('FORM_TO_CAMPAIGN')];
    case OBJECT_TYPE.LANDING_PAGE:
      return [makeDefaultAssociationConfig('LANDING_PAGE_TO_CAMPAIGN')];
    case OBJECT_TYPE.MARKETING_EMAIL:
      return [makeDefaultAssociationConfig('MARKETING_EMAIL_TO_CAMPAIGN')];
    case OBJECT_TYPE.MARKETING_SMS:
      return [makeDefaultAssociationConfig('MARKETING_SMS_TO_CAMPAIGN'), makeDefaultAssociationConfig('MARKETING_SMS_TO_LIST')];
    case OBJECT_TYPE.SITE_PAGE:
      return [makeDefaultAssociationConfig('SITE_PAGE_TO_CAMPAIGN')];
  }
}